/* src/app/component/recharge-wallet-popup/recharge-wallet-popup.component.scss */
.cancel-button {
  background-color: #fff;
  color: #000000;
  border-radius: 8px;
  padding: 0.5rem 1.5rem;
  border: 1px solid #D0D5DD;
  height: 40;
}
.cancel-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
/*# sourceMappingURL=recharge-wallet-popup.component-YCN4EMDL.css.map */
